<template>
  <div class="event-items-management">
    <div class="client-card-list-wrapper">
      <ClientCard v-for="(client, index) in clients" :listEM="listEM" :client="client" :key="client.id" :isNoTrans="index % 4 == 3" :isClear="index % 4 == 0"></ClientCard>
    </div>
  </div>
</template>

<script>
  import ClientCard from './ClientCard';
  export default {
    name: 'event-items-management',
    components: {
      ClientCard
    },
    props: {
      clients: {
        type: Array,
        default: () => []
      },
      listEM: {
        type: Array,
        default: () => []
      }
    }
  };
</script>



// WEBPACK FOOTER //
// ClientCardsManagement.vue?541a15f2